import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import Prism from "prismjs";

export default function CodePanel({
  title,
  code,
  activePanelName,
  setActivePanelName
}) {

  let active = activePanelName === title
  
  // highlights syntax
  useEffect(() => Prism.highlightAll(), []);

  // will claim active panel or set it back to null
  // this feature is opt in
  function handleClick() {
    if (!setActivePanelName) return
    if (active) setActivePanelName(null)
    else setActivePanelName(title)
  }
  return (
    <Container onClick={handleClick} active={active}>
      <Title>{title}</Title>
      <SyntaxHighlighting className={`language-${title}`}>
        <code>{code}</code>
      </SyntaxHighlighting>
    </Container>
  );
}

const Title = styled.h1`
  color: white;
`;

const Container = styled.div`
  box-shadow: 0 4px 3px rgba(0, 0, 0, 0.5);
  padding: 1em;
  line-height: 1.2em;
  height: 600px;
  flex: 0 0 ${props => props.active ? '1000px' : '350px'};
  overflow-y: scroll;
  overflow-x: hidden;
  background: #001628;
  margin-right: 1em;
  border: 1px solid lightgreen;
  transition: 0.2s ease;
  cursor: pointer;
`;

const SyntaxHighlighting = styled.pre`
  /* PrismJS 1.15.0
https://prismjs.com/download.html#themes=prism-tomorrow&languages=markup+css+clike+javascript+python+jsx */
  /**
 * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML
 * Based on https://github.com/chriskempson/tomorrow-theme
 * @author Rose Pritchard
 */

  code[class*="language-"],
  pre[class*="language-"] {
    color: #ccc;
    background: #001628;
    font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
    font-size: 1em;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }

  /* Code blocks */
  pre[class*="language-"] {
    padding: 1em;
    margin: 0.5em 0;
    overflow: auto;
  }

  :not(pre) > code[class*="language-"],
  pre[class*="language-"] {
    background: #2d2d2d;
  }

  /* Inline code */
  :not(pre) > code[class*="language-"] {
    padding: 0.1em;
    border-radius: 0.3em;
    white-space: normal;
  }

  .token.comment,
  .token.block-comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: #999;
  }

  .token.punctuation {
    color: #ccc;
  }

  .token.tag,
  .token.attr-name,
  .token.namespace,
  .token.deleted {
    color: #e2777a;
  }

  .token.function-name {
    color: #6196cc;
  }

  .token.boolean,
  .token.number,
  .token.function {
    color: #f08d49;
  }

  .token.property,
  .token.class-name,
  .token.constant,
  .token.symbol {
    color: #f8c555;
  }

  .token.selector,
  .token.important,
  .token.atrule,
  .token.keyword,
  .token.builtin {
    color: #cc99cd;
  }

  .token.string,
  .token.char,
  .token.attr-value,
  .token.regex,
  .token.variable {
    color: #7ec699;
  }

  .token.operator,
  .token.entity,
  .token.url {
    color: #67cdcc;
  }

  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }

  .token.entity {
    cursor: help;
  }

  .token.inserted {
    color: green;
  }
`;
